import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from 'components/popup/components/DoubleButton';
import Select from 'components/Select';
import VS from 'constants/ValidationShema';
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    text: {
        marginBottom: theme.spacing(2),
    },
    gridContainer: {
        marginBottom: theme.spacing(2)
    },
    fileName: {
        width: 300
    },
    select: {
        width: 200,
        marginLeft: theme.spacing(2)
    },
    parentSelect: {
        width: 200,
    }
}));

function OfferEspdExternalUploadFileTypes(
    {
        items,
        onCancel,
        onSubmit,
        formSubmit,
        positionItems,
        dealingId
    }) {

    const classes = useStyle();

    const formId = useId();
    const positionId = 'position';

    const generateItems = (formikProps) => {
        if (items.length === 0) {
            return <Typography>{Tr("file_extension_error")}</Typography>
        }
        return items.map((item, i) => {
            return (
                <GridBlock key={i} justify="space-between" alignItems="center">
                    <Typography className={classes.fileName}> {item.name}</Typography>

                    <Select
                        id={positionId + i}
                        formikProps={formikProps}
                        items={positionItems}
                        label={Tr('assignment')}
                        className={classes.select}
                    />

                </GridBlock>
            )
        })
    };

    const submitForm = () => {
        formSubmit[formId]()
    };

    const handleSubmit = (values, items) => onSubmit(values, items);

    const generateInitialValues = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[positionId + i] = dealingId;
        }
        return obj
    };

    const generateValidationSchema = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[positionId + i] = VS.number();
        }

        return VS.object(obj)
    };

    if (items === undefined) return '';
    return (
        <Dialog
            open
            title={Tr('choose_position')}
            titleCentered
            maxWidth={'xl'}
            fullWidth={false}
            paperClassName={classes.paperClassName}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('add')}
                onClickFirst={onCancel}
                onClickSecond={submitForm}
            />}
        >
            <Form
                onSubmit={handleSubmit}
                id={formId}
                initialValues={generateInitialValues()}
                validationSchema={generateValidationSchema()}
            >
                {(formikProps) => (
                    <>
                        <GridBlock column className={classes.gridContainer}>
                            {generateItems(formikProps)}
                        </GridBlock>
                    </>
                )}
            </Form>

        </Dialog>
    )
}

OfferEspdExternalUploadFileTypes.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired
    })).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default connect((state) => ({
    formSubmit: state.form,
}), {})(OfferEspdExternalUploadFileTypes);